import { nanoid } from "nanoid";

import { createAlertAction } from "../alerts/alerts.actions";

// A save the server accepted but flagged (e.g. outside someone's work hours) shows as a yellow toast.
export const alertWarnings = (warnings, dispatch) => {
  for (const warning of warnings ?? []) {
    dispatch(createAlertAction(nanoid(), warning.message, true, "warning"));
  }
};
